class Color {
  private r: number
  private g: number
  private b: number
  private tr: number = this.p5.random(0, 10000)
  private tg: number = this.p5.random(0, 10000)
  private tb: number = this.p5.random(0, 10000)

  constructor(private p5: any) {
  }

  getNextColor() {
    this.r = this.p5.noise(this.tr) * 255
    this.g = this.p5.noise(this.tg) * 255
    this.b = this.p5.noise(this.tb) * 255
    const color = this.p5.color(this.r, this.g, this.b)
    this.tr += 0.05
    this.tg += 0.05
    this.tb += 0.05
    return color
  }
}

export default class BeatIndicator {
  private position: any
  private lifespan: number
  private sizeOffset: number
  private readonly sizeVariation = 1
  private readonly minSize = 50
  private readonly maxSize = 400
  private colors: Color[]

  constructor(private p5: any, position: any) {
    this.position = position.copy()
    this.lifespan = 100
    this.sizeOffset = p5.random(0, 10000)
    this.colors = Array(5).fill(null).map(() => new Color(p5))
  }

  run() {
    this.update()
    this.display()
  }

  isDead(): boolean {
    return this.lifespan < 0
  }

  private update() {
    this.lifespan -= 10
  }

  private display() {
    const mappedSize = this.p5.map(this.position.y, 0, this.p5.height, this.minSize, this.maxSize)
    let size = this.p5.noise(this.sizeOffset) * mappedSize + (this.sizeVariation * mappedSize)

    this.p5.noStroke()

    this.colors.forEach((color, index) => {
      this.p5.fill(this.colors[index].getNextColor())
      this.p5.ellipse(this.position.x, this.position.y, size, size)
      size *= 0.6
    })

    this.sizeOffset += 0.1
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/graphics/BeatIndicator.ts